import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import React, {FC} from "react";
import Typography from "@mui/material/Typography";
import CustomDivider from "../../../shared/custom-divider/CustomDivider";
import {IHomeSteps} from "../../../../store/home/Helper";
import {useTranslation} from "react-i18next";
import {useTheme} from "@mui/material/styles";

interface IProps {
    steps: IHomeSteps[]
}

const HorizontalSteps: FC<IProps> = (props) => {
    const {i18n} = useTranslation()
    const theme = useTheme()

    return (
        <Box mt={5.5} sx={{width: '100%'}}>
            <CustomDivider gradientPosition="center" height={3}/>
            <Grid container justifyContent="space-around" sx={{position: 'relative', top: '-14px'}}>
                {props.steps.map((s) => (
                    <Box key={s[`label_${i18n.language}`]} sx={{
                        height: '25px',
                        width: '25px',
                        borderRadius: '50%',
                        bgcolor: theme.palette.primary.main
                    }}/>
                ))}
            </Grid>
            <Grid container>
                {props.steps.map((s) => (
                    <Grid
                        key={s[`label_${i18n.language}`]}
                        container
                        justifyContent="center"
                        size={12 / props.steps.length}>
                        <Typography color="primary" variant='h6' textAlign="center" px={2}>
                            {s[`label_${i18n.language}`]}
                        </Typography>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}

export default HorizontalSteps
